export const isPromise = v => {
    return v && typeof v.then === 'function';
};

export default isPromise;
